import { Discount } from '@/core/models';
import { DELETE, GET, PATCH, POST, PUT } from '@/lib/api/Methods';
import { Paginated } from '@/lib/api/methods.types';
import { ListingPayload } from '../types';
import { IExclusiveMemberBenefits, TClinicPartnerDiscountResponse, TPartnerDiscountResponse } from './discount.types';

export const discountCouponRedemption = (code: string) =>
   POST<{ code: string }, Discount>('/discount/redemption-discount', { code });

export const getClinicDiscounts = () => GET<unknown, TClinicPartnerDiscountResponse>('/discount/discounts-clinic');

export const createClinicPartnerDiscount = (payload: FormData) =>
   POST<FormData, TClinicPartnerDiscountResponse>('/discount/create-clinic-partner-discount', payload);

export const getClinicOrPartnerDiscounts = ({ limit, page, search }: ListingPayload & { search: string }) =>
   GET<ListingPayload & { search: string }, Paginated<TPartnerDiscountResponse>>('/discount/clinic-partner-discounts', {
      limit,
      page,
      search,
   });

export const getDiscountById = async (id: string) => GET<unknown, Discount>(`discount/get-discount/${id}`);

export const updatePartnerDiscounts = (id: string, data: FormData) =>
   PUT<FormData, TClinicPartnerDiscountResponse>(`/discount/update-partner-discount/${id}`, data);

export const deleteDiscount = async (id: string) => DELETE<unknown, Discount>(`discount/delete-partner-discount/${id}`);

export const getExclisiveMembershipBenefits = (owner_id?: string) =>
   GET<{ owner_id?: string | undefined }, Discount[]>('/discount/clinic-partner-benifits', {
      owner_id,
   });

export const changePartnerDiscountStatus = (id: string, status: boolean) =>
   PATCH<unknown, Discount>(`/discount/status-partner-discount/${id}`, {
      status,
   });

export const listOfExclusiveMemberBenefitsForUser = () =>
   GET<unknown, IExclusiveMemberBenefits>('/discount/list-exclusive-members-user');
